import React from "react";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import Autocomplete from "@mui/material/Autocomplete";
import { Box, Button, Divider, Grid, IconButton, TextField, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import OnlinePredictionIcon from "@mui/icons-material/OnlinePrediction";

/** "How would you like to bid": Online (join live auction) and Advance (absentee) bidding. */
export default function BidDialog({
  LOTIDNUMBER,
  amountBid,
  artist,
  auctionId,
  auctionType,
  current,
  dateStart,
  favorite,
  forApproval,
  formatDateTime,
  handleCLickShoAdvance,
  handleClose,
  handleJoinLiveAuction,
  handlepostBid,
  handlickFavorite,
  highestBid,
  incrementData,
  inputValue,
  lotID,
  matches,
  next,
  note,
  open,
  selectedImage,
  setInputValue,
  setPlaceAmount1,
  setShowAdance,
  showAdvance,
  startingPrice,
  timeStart,
  title,
}) {
  return (
    <Dialog
      className="single-product-bell-mt"
      open={open}
      fullWidth
      maxWidth="lg"
      onClose={handleClose}
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: matches ? 2.5 : 0,
          padding: matches ? 3 : 2,
          // Full Width logic: 0 margin pag mobile
          margin: matches ? 2 : 0,
          width: matches ? "calc(100% - 64px)" : "100%",
          height: matches ? "auto" : "100%",
          maxHeight: matches ? "90vh" : "100%",
        },
      }}
    >
      <DialogTitle
        sx={{
          textAlign: "center",
          fontWeight: "bold",
          fontSize: { xs: "0.95rem", sm: "0.875rem", md: "1.5rem" },
          paddingBottom: 1,
        }}
      >
        {showAdvance ? "Select Your Bid" : "How Would You Like To Bid"}
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 20,
            top: 20,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Divider />

      <DialogContent>
        <Grid container spacing={3} mt={1}>

          <Grid
            item
            xs={12} // Buong width sa mobile (image sa itaas)
            md={6} // Half width sa desktop (image sa tabi)
            style={{ display: "block" }} // Pinilit nating maging block para laging kita
          >
            <Box
              sx={{
                backgroundImage: `url(${selectedImage})`,
                backgroundColor: "#ffffff", // Gawing white para malinis tignan kung transparent ang image
                width: "100%",
                height: { xs: 350, sm: 400, md: 450 }, // Tinalasan natin ang height para mas punô
                borderRadius: 1, // Mas maliit na radius para mas professional tignan
                backgroundSize: "contain",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                border: "1px solid #e0e0e0", // Border sa halip na Shadow para hindi "lutang"
                // boxShadow: "none", // Siguradong walang shadow
              }}
            />

            <Box sx={{ textAlign: "center", mt: 2 }}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  fontSize: matches ? 20 : 18,
                  color: "#212529",
                }}
                dangerouslySetInnerHTML={{ __html: artist || "" }}
              />
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 600,
                  fontSize: matches ? 18 : 16,
                  color: "#495057",
                  mt: 0.5,
                }}
                dangerouslySetInnerHTML={{ __html: title || "" }}
              />
            </Box>
          </Grid>


          <Grid item xs={12} md={6}>
            {showAdvance === true ? (
              <div>
                <Box>
                  <Button
                    startIcon={<KeyboardArrowLeftIcon />}
                    onClick={() => setShowAdance(false)}
                    sx={{
                      fontSize: 16,
                      textTransform: "none",
                      fontWeight: "bold",
                      color: "black",
                    }}
                  >
                    BACK
                  </Button>
                </Box>

                <Grid container direction="column" sx={{ mb: 2 }}></Grid>


                <Box sx={{ p: 2, borderRadius: 2 }}>
                  {[
                    {
                      label: "Starting Price",
                      value: parseInt(startingPrice),
                    },
                    {
                      label: "Current Bid",
                      value: current ? parseInt(current) : 0,
                    },
                    {
                      label: "Your Bid",
                      value:
                        amountBid && amountBid !== 1000
                          ? parseInt(amountBid)
                          : highestBid
                          ? parseInt(highestBid)
                          : 0,
                    },
                  ].map((item, index) => (
                    <Box key={item.label}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          py: 1.5,
                        }}
                      >
                        <Typography color="text.secondary">
                          {item.label}
                        </Typography>
                        <Typography
                          sx={{
                            fontWeight: "bold",
                            color:
                              item.label === "Your Bid" &&
                              amountBid &&
                              amountBid !== 1000
                                ? "primary.main"
                                : "inherit",
                          }}
                        >
                          ₱{item.value.toLocaleString()}
                        </Typography>
                      </Box>
                      {index < 2 && <Divider />}
                    </Box>
                  ))}
                </Box>

                <Autocomplete
                  value={
                    amountBid === null || amountBid === 1000
                      ? startingPrice
                      : amountBid
                  }
                  onChange={(event, newValue) => setPlaceAmount1(newValue)}
                  inputValue={inputValue || ""}
                  onInputChange={(event, newInputValue) =>
                    setInputValue(newInputValue)
                  }
                  // DITO ANG PAGBABAGO:
                  // I-filter ang incrementData para ang lalabas lang ay >= startingPrice
                  options={
                    Array.isArray(incrementData)
                      ? incrementData.filter(
                          (price) => price >= startingPrice
                        )
                      : []
                  }
                  getOptionLabel={(option) => String(option)}
                  disablePortal={true}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Amount"
                      sx={{
                        width: "100%",
                        mt: 2,
                        fontSize: matches ? 18 : 14,
                      }}
                    />
                  )}
                />



                <Box sx={{ pt: 3 }}>
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={(e) => handlepostBid(e, next)}
                    sx={{
                      backgroundColor: "#343a40",
                      py: 1.5,
                      "&:hover": { backgroundColor: "#23272b" },
                      fontSize: { xs: "0.875rem", md: "1rem" },
                    }}
                  >
                    Advance Bid
                  </Button>
                </Box>
              </div>
            ) : (
              <div>
                {auctionType === "TIME_AUCTION" ? (
                  ""
                ) : (
                  <Box
                    sx={{
                      p: 2,
                      border: "1px solid #e0e0e0",
                      borderRadius: 2,
                      backgroundColor: "#f9f9f9",
                      mb: 3,
                    }}
                  >
                    <Box
                      sx={{ display: "flex", alignItems: "center", mb: 1 }}
                    >
                      <OnlinePredictionIcon
                        color="primary"
                        sx={{ mr: 1 }}
                      />
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: "bold",
                          fontSize: {
                            xs: "0.90rem",
                            sm: "0.875rem",
                            md: "1rem",
                          },
                        }}
                      >
                        ONLINE
                      </Typography>
                    </Box>

                    {forApproval ? (
                      /* --- CASE 1: KAPAG FOR APPROVAL (Note lang, walang buttons) --- */
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                          mt: 1,
                          mb: 1,
                          backgroundColor: "#fff8e1",
                          border: "1px solid #ffe082",
                          padding: 2,
                          borderRadius: 1,
                          fontSize: {
                            xs: "0.75rem",
                            sm: "0.875rem",
                            md: "1rem",
                          },
                        }}
                      >
                        <strong>Note:</strong> {note}
                      </Typography>
                    ) : (
                      /* --- CASE 2: KAPAG HINDI PA NAG-REQUEST (Join Live Auction Button) --- */

                      <>
                        <Typography
                          sx={{
                            mb: 2,
                            fontSize: {
                              xs: "0.85rem",
                              sm: "0.875rem",
                              md: "1rem",
                            },
                          }}
                        >
                          Participate in Live-Online Auction with Leon
                          Gallery’s Real-Time Bidding Platform
                        </Typography>

                        <Button
                          variant="contained"
                          fullWidth
                          onClick={(e) => handleJoinLiveAuction(auctionId)}
                          sx={{
                            backgroundColor: "#343a40",
                            "&:hover": {
                              backgroundColor: "#23272b",
                            },
                            fontSize: {
                              xs: "0.75rem",
                              sm: "0.875rem",
                              md: "1rem",
                            },
                          }}
                        >
                          Join Live Auction
                        </Button>
                      </>
                    )}
                  </Box>
                )}

                {lotID === 198 ? (
                  ""
                ) : (
                  <Box
                    sx={{
                      p: 2,
                      border: "1px solid #e0e0e0",
                      borderRadius: 2,
                      backgroundColor: "#f9f9f9",
                    }}
                  >
                    <Box
                      sx={{ display: "flex", alignItems: "center", mb: 1 }}
                    >
                      <AssignmentTurnedInIcon
                        color="primary"
                        sx={{ mr: 1 }}
                      />
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: "bold",
                          fontSize: { xs: "0.90rem", md: "1rem" },
                        }}
                      >
                        ADVANCE
                      </Typography>
                    </Box>
                    <Typography
                      sx={{
                        mb: 2,
                        fontSize: { xs: "0.85rem", md: "1rem" },
                      }}
                    >
                      Leave an absentee bid before{" "}
                      <strong>
                        {formatDateTime(dateStart, timeStart)}
                      </strong>
                      .
                    </Typography>

                    <Button
                      variant="contained"
                      fullWidth
                      onClick={handleCLickShoAdvance}
                      sx={{
                        backgroundColor: "#333", // Base color na gusto mo
                        borderRadius: "4px",
                        fontWeight: 700,
                        padding: "12px",
                        textTransform: "none",
                        "&:hover": {
                          backgroundColor: "#333", // Hover color na pareho pa rin
                          opacity: 0.85, // Nagdagdag ako ng opacity para may feedback pa rin sa user pag-hover
                          boxShadow: "none",
                        },
                      }}
                    >
                      Place Absentee Bid
                    </Button>
                  </Box>
                )}
              </div>
            )}
          </Grid>
        </Grid>
      </DialogContent>

      <Divider />

      <DialogActions
        sx={{ justifyContent: "space-between", px: matches ? 3 : 2, py: 2 }}
      >
        <Button
          variant="outlined"
          onClick={handleClose}
          sx={{ color: "#343a40", borderColor: "#343a40" }}
        >
          Cancel
        </Button>
        <Button
          onClick={() => handlickFavorite(LOTIDNUMBER)}
          startIcon={
            favorite === 1 ? (
              <FavoriteIcon color="error" />
            ) : (
              <FavoriteBorderIcon />
            )
          }
          sx={{ fontSize: { xs: "0.65rem", sm: "0.875rem", md: "1rem" } }}
        >
          {favorite === 1 ? "Unfollow" : "Follow This Lot"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
